module.exports = __webpack_public_path__ + "static/img/py.54ca730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/py.png
// module id = rY/F
// module chunks = 26